import { render, staticRenderFns } from "./ModalAddAssessment.vue?vue&type=template&id=0e83ec97&"
import script from "./ModalAddAssessment.vue?vue&type=script&lang=js&"
export * from "./ModalAddAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports